namespace Areas {
    "use strict";

    const exportButtonName = "exportButton";

    export function addExport(e: any) {
        const grid: DevExpress.ui.dxDataGrid = e.component;

        addButtonToToolbar(e.toolbarOptions, {
            elementAttr: { id: exportButtonName, "class": "dx-datagrid-export-button" },
            text: "Export",
            hint: "Export all rows to Excel",
            type: "normal",
            icon: "xlsxfile",
            onClick: exportData(grid)
        }, "after");
    }

    export function exportToExcel(e: any) {
        exportData(e.component)(null);
    }

    export function exportPivotToExcel(e: any) {
        exportPivotData(e.component)(null);
    }

    function exportData(grid: DevExpress.ui.dxDataGrid) {
        return (e: any) => {
            const fileName: string = grid.option("gridName") as string;

            var workbook = new ExcelJS.Workbook();
            var worksheet = workbook.addWorksheet('Main sheet');
            DevExpress.excelExporter.exportDataGrid({
                worksheet: worksheet,
                component: grid,
                customizeCell: function(options) {
                    var {gridCell, excelCell} = options;

                    if(gridCell.rowType === 'data') {
                        if (gridCell.column.dataType === 'datetime') {
                            excelCell.numFmt = 'mm/dd/yyyy h:mm AM/PM';
                        } else if (gridCell.column.dataType === 'date') {
                            excelCell.numFmt = 'mm/dd/yyyy';
                        }
                    }
                }
            }).then(function() {
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
                });
            });
        }
    }

    export function exportPivotData(grid: DevExpress.ui.dxPivotGrid) {
        return (e: any) => {
            const fileName: string = grid.option("gridName") as string;

            var workbook = new ExcelJS.Workbook();
            var worksheet = workbook.addWorksheet('Main sheet');
            DevExpress.excelExporter.exportPivotGrid({
                worksheet: worksheet,
                component: grid,
            }).then(function() {
                workbook.xlsx.writeBuffer().then(function(buffer) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), `${fileName}.xlsx`);
                });
            });
        }
    }

    declare module ExcelJS {

        export interface XlsxWriteOptions {
        }

        export interface Xlsx {
            writeBuffer(options?: Partial<XlsxWriteOptions>): Promise<Buffer>;
        }
        export interface Worksheet {
        }

        export interface AddWorksheetOptions {
        }
        export class Workbook {
            addWorksheet(name?: string, options?: Partial<AddWorksheetOptions>): Worksheet;
            readonly xlsx: Xlsx;
        }
    }

}
